import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HistoricoClinicoConsultaDto, HistoricoClinicoEdicaoDto, HistoricoClinicoInsercaoDto } from '../dtos/historias-clinicas/historia-clinica-dto';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class HistoriaClinicaService {

  constructor(private http: HttpClient, private url: UrlService) { }

  consultarHistorico(id: number): Observable<HistoricoClinicoConsultaDto> {
    return this.http.get<HistoricoClinicoConsultaDto>(this.url.url(`pacientes/historias-clinicas/historicos/${id}`));
  }

  listarHistoricos(pessoaId: number): Observable<HistoricoClinicoConsultaDto[]> {
    let params: HttpParams = new HttpParams();
    params = params.append('pessoaId', pessoaId);

    return this.http.get<HistoricoClinicoConsultaDto[]>(this.url.url(`pacientes/historias-clinicas/historicos`), { params: params });
  }

  salvarHistorico(dto: HistoricoClinicoInsercaoDto | HistoricoClinicoEdicaoDto): Observable<HistoricoClinicoConsultaDto> {
    if('id' in dto) {
      return this.http.patch<HistoricoClinicoConsultaDto>(this.url.url('pacientes/historias-clinicas/historicos'), dto);
    }

    return this.http.post<HistoricoClinicoConsultaDto>(this.url.url('pacientes/historias-clinicas/historicos'), dto);
  }

  excluirHistorico(id: number): Observable<void> {
    return this.http.delete<void>(this.url.url(`pacientes/historias-clinicas/historicos/${id}`));
  }

  obterUltimoHistorico(data: Date, pessoaId: number): Observable<HistoricoClinicoConsultaDto | null> {
    let params: HttpParams = new HttpParams();
    params = params.append('data', data.toISOString());
    params = params.append('pessoaId', pessoaId);
    return this.http.get<HistoricoClinicoConsultaDto | null>(this.url.url(`pacientes/historias-clinicas/historicos/ultimo`), { params: params });
  }

}
